<div *ngIf="transactions$ | async as data; else loading" class="flex-col" style="font-family: 'Open Sans';">
  <div *ngIf="data.appointment; else noAppointment">
    <div class="flex flex-col">
      <div class="flex flex-col w-full shadow-lg bg-white rounded-lg p-2.5 sm:p-4 mt-7 mb-3 space-y-2">
        <div class="flex flex-row mb-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
            <path
              d="M7 21.3431V22.5098C7 22.8403 6.88839 23.1172 6.66517 23.3404C6.44117 23.5644 6.16389 23.6764 5.83333 23.6764H4.66667C4.33611 23.6764 4.05922 23.5644 3.836 23.3404C3.612 23.1172 3.5 22.8403 3.5 22.5098V13.1764L5.95 6.17643C6.06667 5.82643 6.27589 5.54449 6.57767 5.3306C6.87867 5.11671 7.21389 5.00977 7.58333 5.00977H20.4167C20.7861 5.00977 21.1217 5.11671 21.4235 5.3306C21.7245 5.54449 21.9333 5.82643 22.05 6.17643L24.5 13.1764V22.5098C24.5 22.8403 24.388 23.1172 24.164 23.3404C23.9408 23.5644 23.6639 23.6764 23.3333 23.6764H22.1667C21.8361 23.6764 21.5592 23.5644 21.336 23.3404C21.112 23.1172 21 22.8403 21 22.5098V21.3431H7ZM6.76667 10.8431H21.2333L20.0083 7.3431H7.99167L6.76667 10.8431ZM8.75 17.8431C9.23611 17.8431 9.64911 17.6728 9.989 17.3321C10.3297 16.9922 10.5 16.5792 10.5 16.0931C10.5 15.607 10.3297 15.194 9.989 14.8541C9.64911 14.5134 9.23611 14.3431 8.75 14.3431C8.26389 14.3431 7.85089 14.5134 7.511 14.8541C7.17033 15.194 7 15.607 7 16.0931C7 16.5792 7.17033 16.9922 7.511 17.3321C7.85089 17.6728 8.26389 17.8431 8.75 17.8431ZM19.25 17.8431C19.7361 17.8431 20.1491 17.6728 20.489 17.3321C20.8297 16.9922 21 16.5792 21 16.0931C21 15.607 20.8297 15.194 20.489 14.8541C20.1491 14.5134 19.7361 14.3431 19.25 14.3431C18.7639 14.3431 18.3509 14.5134 18.011 14.8541C17.6703 15.194 17.5 15.607 17.5 16.0931C17.5 16.5792 17.6703 16.9922 18.011 17.3321C18.3509 17.6728 18.7639 17.8431 19.25 17.8431Z"
              fill="#BBBBBB" />
          </svg>
          <div class="flex flex-col ml-3">
            <ng-container *ngIf="data.workOrder.embedded?.vehicle as vehicle; else freeformVehicle">
              <span class="font-semibold text-lg" style="color: #444">
                {{ vehicle.year }} {{ vehicle.make }} {{ vehicle.model }}
              </span>
              <span class="flex flex-row items-center h-3 text-xs font-semibold" style="color: #555">
                (ID: {{ vehicle.id }})</span>
            </ng-container>
            <ng-template #freeformVehicle>
              <div class="flex flex-row items-center h-3 text-xs font-semibold" style="color: #555">{{
                data.appointment?.vehicleDescription || 'No vehicle indicated' }}</div>
            </ng-template>
          </div>
        </div>

        <div class="flex flex-row items-center w-full mt-2 text-sm" style="font-family: 'Open Sans'; color: #555">
          <div *ngIf="data.appointment.odometerIn; else noOdometer">
            <span class="font-bold">Odometer: </span>
            <span class="font-normal">
              {{data.appointment.odometerIn | number}}
            </span>
          </div>
          <img
            *ngIf="data.appointment.odometerUpdatedByVehicleDiagnostic === true || data.workOrder.odometerUpdatedByVehicleDiagnostic === true"
            class="pl-2 h-3.5 w-auto" src="assets/savi-icon.png" alt="...">
          <ng-template #noOdometer>
            <span class="font-bold">No odometer value indicated</span>
          </ng-template>
        </div>

        <div class="w-full mt-2 text-sm flex flex-row items-center" style="font-family: 'Open Sans'; color: #555">
          <div *ngIf="data.workOrder.embedded?.vehicle?.vin; else noVehicleVin" class="text-sm"
            style="font-family: 'Open Sans'; color: #555">
            <span class="font-bold">VIN: </span>
            <span class="font-normal">{{data.workOrder.embedded?.vehicle?.vin}}</span>
          </div>
          <ng-template #noVehicleVin>
            <span class="font-bold">No VIN indicated</span>
          </ng-template>
        </div>

        <div class="flex flex-row" *ngIf="systemControl$ | async as systemControls">
          <div class="w-full mt-2 text-sm" style="font-family: 'Open Sans'; color: #555">
            <div *ngIf="data.workOrder.embedded?.vehicle?.licensePlateNumber; else noLicensePlate">
              <span class="font-bold">License plate: </span>
              <span class="font-normal">{{data.workOrder.embedded?.vehicle?.licensePlateNumber}}</span>
            </div>
            <ng-template #noLicensePlate>
              <span class="font-bold">No license plate indicated</span>
            </ng-template>
          </div>

          <div class="flex w-1/3 md:w-1/4 flex-row space-x-2 place-content-end"
            *ngIf="systemControls?.CL_GM_TIRE_CENTRAL_WIDGET?.value === '1'">
            <button style="font-family: 'Open Sans'"
              [ngStyle]="{ background: toggleTireFinderWidgetValue ? 'rgba(0, 84, 166, 1)': 'rgba(255, 255, 255, 1)'}"
              class="sm:flex w-full place-items-center h-7 place-content-center px-3 py-1.5 rounded-md cursor-pointer border border-quorum-blue"
              (click)="toggleTireFinderWidget(toggleTireFinderWidgetValue)">
              <span class="font-normal text-sm"
                [ngClass]="toggleTireFinderWidgetValue ? 'text-white': 'text-quorum-blue'">
                GM Tire Central
              </span>
            </button>
          </div>
        </div>

        <div class="flex flex-col w-full shadow-lg bg-white rounded-lg p-3 sm:p-4 space-y-2 items-center">
          <div class="flex flex-row w-full items-start justify-between">
            <div class="flex flex-row items-center">
              <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16.8053 8.02456H1M12.4149 1V4.51228M5.39035 1V4.51228M7.58553 11.5368L8.90263 10.6588V15.0491M7.80504 15.0491H10.0002M5.21474 18.5614H12.5905C14.0658 18.5614 14.8035 18.5614 15.367 18.2743C15.8626 18.0217 16.2656 17.6188 16.5182 17.1231C16.8053 16.5596 16.8053 15.822 16.8053 14.3467V6.97088C16.8053 5.49558 16.8053 4.75793 16.5182 4.19444C16.2656 3.69879 15.8626 3.2958 15.367 3.04325C14.8035 2.75614 14.0658 2.75614 12.5905 2.75614H5.21474C3.73944 2.75614 3.00179 2.75614 2.4383 3.04325C1.94265 3.2958 1.53966 3.69879 1.28711 4.19444C1 4.75793 1 5.49558 1 6.97088V14.3467C1 15.822 1 16.5596 1.28711 17.1231C1.53966 17.6188 1.94265 18.0217 2.4383 18.2743C3.00179 18.5614 3.73944 18.5614 5.21474 18.5614Z"
                  stroke="#BBBBBB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <div class="flex flex-wrap font-semibold text-lg h-full ml-3 mr-5"
                style="font-family: 'Open Sans'; color: #444">
                <span>{{data.appointment.dateTime | date: 'd MMMM, y'}}</span>
                <div class="whitespace-nowrap">
                  <span class="font-light whitespace-pre"> at </span>
                  <span>{{data.appointment.dateTime | date: 'h:mm a'}}</span>
                </div>
              </div>
            </div>
            <div class="mt-1" (click)="mediaGalleryDialog(data.appointment.vehicleId)">
              <svg width="18" viewBox="0 0 17 16" fill="#0054A6" stroke="#0054A6" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0.426758 3.0664C0.426758 1.96495 1.32547 1.06885 2.43013 1.06885H14.4504C15.555 1.06885 16.4538 1.96495 16.4538 3.0664V13.0542C16.4538 14.1556 15.555 15.0517 14.4504 15.0517H2.43013C1.32547 15.0517 0.426758 14.1556 0.426758 13.0542V3.0664ZM2.43013 2.06762C1.87587 2.06762 1.42845 2.51374 1.42845 3.0664V10.3511L3.54788 8.23846C4.03564 7.75146 4.82804 7.75146 5.31913 8.23846L7.43857 10.3511L11.5614 6.24091C12.0491 5.75391 12.8415 5.75391 13.3326 6.24091L15.4521 8.35352V3.0664C15.4521 2.51374 15.0047 2.06762 14.4504 2.06762H2.43013ZM1.42845 11.7621V13.0542C1.42845 13.6068 1.87587 14.0529 2.43013 14.0529H3.72592L6.73098 11.0566L4.61221 8.94333C4.51498 8.84705 4.35524 8.84705 4.25815 8.94333L1.42845 11.7621ZM3.43182 4.56456C3.43182 4.02935 3.71817 3.53463 4.18309 3.26735C4.648 2.99942 5.2207 2.99942 5.68562 3.26735C6.15054 3.53463 6.43688 4.02949 6.43688 4.56456C6.43688 5.09964 6.15054 5.5945 5.68562 5.86177C5.2207 6.12971 4.648 6.12971 4.18309 5.86177C3.71817 5.5945 3.43182 5.09964 3.43182 4.56456ZM5.4352 4.56456C5.4352 4.2889 5.21082 4.06518 4.93435 4.06518C4.65789 4.06518 4.43351 4.2889 4.43351 4.56456C4.43351 4.84023 4.65789 5.06395 4.93435 5.06395C5.21082 5.06395 5.4352 4.84023 5.4352 4.56456ZM12.6257 6.94578C12.5285 6.8495 12.3687 6.8495 12.2717 6.94578L5.1411 14.0529H14.4504C15.0047 14.0529 15.4521 13.6068 15.4521 13.0542V9.76459L12.6257 6.94578Z"
                  stroke-width="0.5" stroke-miterlimit="10" />
              </svg>
            </div>
          </div>
          <div class="flex flex-row w-full justify-between space-x-2 items-center">
            <div class="flex flex-col sm:flex-row text-sm self-start" style="font-family: 'Open Sans'; color: #555">
              <span class="font-bold whitespace-pre">Service Advisor: </span>
              <span class="font-normal">{{
                data.appointment.embedded?.serviceAdvisorAssociate?.firstName
                ? data.appointment.embedded.serviceAdvisorAssociate.firstName : '' }}
                {{ data.appointment.embedded?.serviceAdvisorAssociate?.lastName ?
                data.appointment.embedded.serviceAdvisorAssociate.lastName : '' }}</span>
            </div>
            <div class="flex text-sm self-start" style="font-family: 'Open Sans'; color: #555; min-width: 30%;">
              <div *ngIf="data.workOrder.embedded?.customerAssociate; else freeformCustomer"
                class="flex flex-col sm:flex-row">
                <span class="font-bold whitespace-pre">Client: </span>
                <span class="font-normal">{{ data.workOrder.embedded?.customerAssociate?.firstName }}
                  {{ data.workOrder.embedded?.customerAssociate?.lastName }}</span>
              </div>
              <ng-template #freeformCustomer>
                <div class="flex flex-col sm:flex-row">
                  <span class="font-bold whitespace-pre">Client: </span>
                  <span class="font-normal">{{ data.appointment?.customerName || 'No client indicated' }}</span>
                </div>
              </ng-template>
            </div>
            <div class="w-4"></div> <!-- empty block for spacing purposes -->
          </div>
        </div>
      </div>

      <!-- <div class="flex flex-row font-medium">
        <div fxLayout="row">
          <span data-cy="service-code-span">{{
            data?.appointment?.embedded?.serviceCode
            ? data?.appointment?.embedded?.serviceCode.description
            : 'No service code indicated'
            }}</span>
          <span class="primary-bullet ml-1">·</span>
          <span *ngIf="data.appointment.promisedDateTime; else noPromisedTime" data-cy="promised-time-span">Promised by
            {{ data.appointment.promisedDateTime | date: 'shortTime' }} on
            {{ data.appointment.promisedDateTime | date: 'mediumDate' }}</span>
          <ng-template class="content-start" #noPromisedTime>
            <span data-cy="no-promised-time-span">No promised time indicated</span>
          </ng-template>
        </div>
      </div> -->

      <!-- <span data-cy="ride-preference-span">{{
        data?.appointment?.embedded?.transportOption
        ? 'Ride preference is ' + data.appointment.embedded.transportOption.name
        : 'No ride preference indicated'
        }}</span> -->
    </div>


  </div>
  <ng-template #noAppointment>
    <div class="flex flex-col w-full shadow-lg bg-white rounded-lg p-2.5 sm:p-4 mt-7 mb-3 space-y-2">
      <div class="flex flex-row justify-between items-start">
        <div class="flex flex-row mb-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
            <path
              d="M7 21.3431V22.5098C7 22.8403 6.88839 23.1172 6.66517 23.3404C6.44117 23.5644 6.16389 23.6764 5.83333 23.6764H4.66667C4.33611 23.6764 4.05922 23.5644 3.836 23.3404C3.612 23.1172 3.5 22.8403 3.5 22.5098V13.1764L5.95 6.17643C6.06667 5.82643 6.27589 5.54449 6.57767 5.3306C6.87867 5.11671 7.21389 5.00977 7.58333 5.00977H20.4167C20.7861 5.00977 21.1217 5.11671 21.4235 5.3306C21.7245 5.54449 21.9333 5.82643 22.05 6.17643L24.5 13.1764V22.5098C24.5 22.8403 24.388 23.1172 24.164 23.3404C23.9408 23.5644 23.6639 23.6764 23.3333 23.6764H22.1667C21.8361 23.6764 21.5592 23.5644 21.336 23.3404C21.112 23.1172 21 22.8403 21 22.5098V21.3431H7ZM6.76667 10.8431H21.2333L20.0083 7.3431H7.99167L6.76667 10.8431ZM8.75 17.8431C9.23611 17.8431 9.64911 17.6728 9.989 17.3321C10.3297 16.9922 10.5 16.5792 10.5 16.0931C10.5 15.607 10.3297 15.194 9.989 14.8541C9.64911 14.5134 9.23611 14.3431 8.75 14.3431C8.26389 14.3431 7.85089 14.5134 7.511 14.8541C7.17033 15.194 7 15.607 7 16.0931C7 16.5792 7.17033 16.9922 7.511 17.3321C7.85089 17.6728 8.26389 17.8431 8.75 17.8431ZM19.25 17.8431C19.7361 17.8431 20.1491 17.6728 20.489 17.3321C20.8297 16.9922 21 16.5792 21 16.0931C21 15.607 20.8297 15.194 20.489 14.8541C20.1491 14.5134 19.7361 14.3431 19.25 14.3431C18.7639 14.3431 18.3509 14.5134 18.011 14.8541C17.6703 15.194 17.5 15.607 17.5 16.0931C17.5 16.5792 17.6703 16.9922 18.011 17.3321C18.3509 17.6728 18.7639 17.8431 19.25 17.8431Z"
              fill="#BBBBBB" />
          </svg>
          <div class="flex flex-col ml-3">
            <ng-container *ngIf="data.workOrder.embedded?.vehicle as vehicle; else freeformVehicle">
              <span class="font-semibold text-lg" style="color: #444">
                {{ vehicle.year }} {{ vehicle.make }} {{ vehicle.model }}
              </span>
              <span class="flex flex-row items-center h-3 text-xs font-semibold" style="color: #555">
                (ID: {{ vehicle.id }})</span>
            </ng-container>
            <ng-template #freeformVehicle>
              <div class="flex flex-row items-center h-3 text-xs font-semibold" style="color: #555">{{
                data.appointment?.vehicleDescription || 'No vehicle indicated' }}</div>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="flex flex-row items-center w-full mt-2 text-sm" style="font-family: 'Open Sans'; color: #555">
        <div *ngIf="data.workOrder.odometerIn; else noOdometer">
          <span class="font-bold">Odometer: </span>
          <span class="font-normal">
            {{data.workOrder.odometerIn | number}}
          </span>
        </div>
        <img *ngIf="data.workOrder.odometerUpdatedByVehicleDiagnostic === true" class="pl-2 h-3.5 w-auto"
          src="assets/savi-icon.png" alt="...">
        <ng-template #noOdometer>
          <span class="font-bold">No odometer value indicated</span>
        </ng-template>
      </div>

      <div class="w-full mt-2 text-sm flex flex-row items-center" style="font-family: 'Open Sans'; color: #555">
        <div *ngIf="data.workOrder.embedded?.vehicle?.vin; else noVehicleVin" class="text-sm"
          style="font-family: 'Open Sans'; color: #555">
          <span class="font-bold">VIN: </span>
          <span class="font-normal">{{data.workOrder.embedded?.vehicle?.vin}}</span>
        </div>
        <ng-template #noVehicleVin>
          <span class="font-bold">No VIN indicated</span>
        </ng-template>
      </div>

      <div class="flex flex-row" *ngIf="systemControl$ | async as systemControls">
        <div class="w-full mt-2 text-sm" style="font-family: 'Open Sans'; color: #555">
          <div *ngIf="data.workOrder.embedded?.vehicle?.licensePlateNumber; else noLicensePlate">
            <span class="font-bold">License plate: </span>
            <span class="font-normal">{{data.workOrder.embedded?.vehicle?.licensePlateNumber}}</span>
          </div>
          <ng-template #noLicensePlate>
            <span class="font-bold">No license plate indicated</span>
          </ng-template>
        </div>

        <div class="flex w-1/3 md:w-1/4 flex-row space-x-2 place-content-end"
          *ngIf="systemControls?.CL_GM_TIRE_CENTRAL_WIDGET?.value === '1'">
          <button style="font-family: 'Open Sans'"
            [ngStyle]="{ background: toggleTireFinderWidgetValue ? 'rgba(0, 84, 166, 1)': 'rgba(255, 255, 255, 1)'}"
            class="sm:flex w-full place-items-center h-7 place-content-center px-3 py-1.5 rounded-md cursor-pointer border border-quorum-blue"
            (click)="toggleTireFinderWidget(toggleTireFinderWidgetValue)">
            <span class="font-normal text-sm"
              [ngClass]="toggleTireFinderWidgetValue ? 'text-white': 'text-quorum-blue'">
              GM Tire Central
            </span>
          </button>
        </div>
      </div>
    </div>

    <div class="flex flex-col w-full shadow-lg bg-white rounded-lg p-3 sm:p-4 space-y-2 items-center">
      <div class="flex flex-row w-full justify-between space-x-2 items-center">
        <div class="flex flex-col sm:flex-row text-sm self-start" style="font-family: 'Open Sans'; color: #555">
          <span class="font-bold whitespace-pre">Service Advisor: </span>
          <span class="font-normal">{{ data.workOrder.embedded?.serviceAdvisorAssociate?.firstName
            ? data.workOrder.embedded.serviceAdvisorAssociate.firstName : '' }}
            {{ data.workOrder.embedded?.serviceAdvisorAssociate?.lastName ?
            data.workOrder.embedded.serviceAdvisorAssociate.lastName : '' }}</span>
        </div>
        <div class="flex text-sm self-start" style="font-family: 'Open Sans'; color: #555; min-width: 30%;">
          <div *ngIf="data.workOrder.embedded?.customerAssociate; else freeformCustomer"
            class="flex flex-col sm:flex-row ">
            <span class="font-bold whitespace-pre">Client: </span>
            <span class="font-normal">{{ data.workOrder.embedded?.customerAssociate?.firstName }}
              {{ data.workOrder.embedded?.customerAssociate?.lastName }}</span>
          </div>
          <ng-template #freeformCustomer>
            <div class="flex flex-col sm:flex-row">
              <span class="font-bold whitespace-pre">Client: </span>
              <span class="font-normal">{{ data.appointment?.customerName || 'No client indicated' }}</span>
            </div>
          </ng-template>
        </div>
        <div *ngIf="data.workOrder.embedded?.vehicle as vehicle" (click)="mediaGalleryDialog(vehicle.id)">
          <svg width="18" viewBox="0 0 17 16" fill="#0054A6" stroke="#0054A6" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0.426758 3.0664C0.426758 1.96495 1.32547 1.06885 2.43013 1.06885H14.4504C15.555 1.06885 16.4538 1.96495 16.4538 3.0664V13.0542C16.4538 14.1556 15.555 15.0517 14.4504 15.0517H2.43013C1.32547 15.0517 0.426758 14.1556 0.426758 13.0542V3.0664ZM2.43013 2.06762C1.87587 2.06762 1.42845 2.51374 1.42845 3.0664V10.3511L3.54788 8.23846C4.03564 7.75146 4.82804 7.75146 5.31913 8.23846L7.43857 10.3511L11.5614 6.24091C12.0491 5.75391 12.8415 5.75391 13.3326 6.24091L15.4521 8.35352V3.0664C15.4521 2.51374 15.0047 2.06762 14.4504 2.06762H2.43013ZM1.42845 11.7621V13.0542C1.42845 13.6068 1.87587 14.0529 2.43013 14.0529H3.72592L6.73098 11.0566L4.61221 8.94333C4.51498 8.84705 4.35524 8.84705 4.25815 8.94333L1.42845 11.7621ZM3.43182 4.56456C3.43182 4.02935 3.71817 3.53463 4.18309 3.26735C4.648 2.99942 5.2207 2.99942 5.68562 3.26735C6.15054 3.53463 6.43688 4.02949 6.43688 4.56456C6.43688 5.09964 6.15054 5.5945 5.68562 5.86177C5.2207 6.12971 4.648 6.12971 4.18309 5.86177C3.71817 5.5945 3.43182 5.09964 3.43182 4.56456ZM5.4352 4.56456C5.4352 4.2889 5.21082 4.06518 4.93435 4.06518C4.65789 4.06518 4.43351 4.2889 4.43351 4.56456C4.43351 4.84023 4.65789 5.06395 4.93435 5.06395C5.21082 5.06395 5.4352 4.84023 5.4352 4.56456ZM12.6257 6.94578C12.5285 6.8495 12.3687 6.8495 12.2717 6.94578L5.1411 14.0529H14.4504C15.0047 14.0529 15.4521 13.6068 15.4521 13.0542V9.76459L12.6257 6.94578Z"
              stroke-width="0.5" stroke-miterlimit="10" />
          </svg>
        </div>
      </div>
    </div>
  </ng-template>
</div>
<ng-template #loading>
  <div class="flex flex-col">
    <div class="animated-background flex flex-col w-full shadow-lg bg-white h-40 rounded-lg mt-7 mb-3">
    </div>
    <div class="animated-background flex flex-col w-full shadow-lg bg-white h-14 rounded-lg">
    </div>
  </div>
</ng-template>
